
/* =========================
   FOLLOWUPS
========================= */

import apiClient from "../../../api/client";

export const createFollowup=(

    leadId,

    payload

)=>

    apiClient.post(

        `/crm/leads/leads/${leadId}/followups`,

        payload

    );

export const getLeadFollowups=(

    leadId

)=>

    apiClient.get(

        `/crm/leads/leads/${leadId}/followups`

    );

export const getTodayFollowups=()=>

    apiClient.get(

        "/crm/leads/followups/today"

    );

export const completeFollowup=(

    followupId

)=>

    apiClient.patch(

        `/crm/leads/followups/${followupId}/complete`

    );

export const deleteFollowup=(

    followupId

)=>

    apiClient.delete(

        `/crm/leads/followups/${followupId}`

    );